import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';

function* fetchAll({ auditLogsParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const pageNo = auditLogsParams?.pageNo || 1;
    let dateFrom = 'null';
    let dateTo = 'null';
    let userEmails = 'null';
    let actions = 'null';
    let entities = 'null';

    if (auditLogsParams?.dateRange?.length === 2) {
      dateFrom = auditLogsParams.dateRange[0].format('YYYY-MM-DD');
      dateTo = auditLogsParams.dateRange[1].format('YYYY-MM-DD');
    }

    if (auditLogsParams?.userEmails?.length > 0) {
      userEmails = auditLogsParams.userEmails.join(',');
    }

    if (auditLogsParams?.actions?.length > 0) {
      actions = auditLogsParams.actions.join(',');
    }

    if (auditLogsParams?.entities?.length > 0) {
      entities = auditLogsParams.entities.join(',');
    }

    const route = `Reports/AuditLogs/${pageNo}/${dateFrom}/${dateTo}/${userEmails}/${actions}/${entities}`;

    const { data } = yield call(api.get, {
      route,
    });
    const allAuditLogs = data;
    yield put(Actions.setAll({ allAuditLogs }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchUsers() {
  try {
    const { data } = yield call(api.get, {
      route: 'userarea/getallusers',
    });
    const users = data;
    yield put(Actions.setUsers({ users }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err);
  }
}

export default function* auditLogsSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ALL, fetchAll), takeLatest(ActionTypes.FETCH_USERS, fetchUsers)]);
}
